import { Disposer } from "../Infra/Disposer";
import { SmartAuthProvider } from "../Logic/SmartAuthManager";
export class FastenCallbackViewModel {
    constructor(container) {
        this.container = container;
        this.disposer = new Disposer();
        this.smartAuthManager = container.smartAuthManager;
    }
    run() {
        this.disposer.reaction(() => this.smartAuthManager.state, () => {
            if (this.smartAuthManager.hasCompletedAuth) {
                const smartAuthData = this.smartAuthManager.getSmartAuthData();
                if (!smartAuthData || smartAuthData.provider !== SmartAuthProvider.FASTEN) {
                    console.error("No smart auth data found for fasten callback");
                    return;
                }
                window.location.hash = smartAuthData.callbackHash;
            }
        }, { fireImmediately: true, name: "FastenCallbackViewModel_smartAuthManagerState" });
    }
    stop() {
        this.disposer.dispose();
    }
}
